import useDarkMode from "@fisch0920/use-dark-mode";
import {
  Button,
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
} from "@heroui/react";

import { ReactComponent as Sun } from "../assets/img/sun.svg";
import { ReactComponent as Moon } from "../assets/img/moon.svg";
import { useHomeTeam } from "../hooks/useHomeTeam";
import { useTheme } from "../hooks/useTheme";

function Header() {
  const darkMode = useDarkMode();
  const { colors } = useTheme();
  const { name, code } = useHomeTeam();

  return (
    <header>
      <Navbar
        position="static"
        height="5rem"
        maxWidth="full"
        classNames={{
          wrapper: "px-6 bg-secondary",
        }}
      >
        <NavbarContent>
          <NavbarBrand>
            <h2
              className={`font-[Futura] text-lg leading-[0.9] tracking-wider ${
                code === "HNS" || code === "DAD" ? "text-black" : "text-yellow"
              }`}
              style={{ textShadow: `-1px 1px 0 hsl(var(--heroui-pink))` }}
            >
              {name}
            </h2>
          </NavbarBrand>
        </NavbarContent>
        <NavbarContent justify="end">
          <NavbarItem>
            <Button
              variant="flat"
              isIconOnly={true}
              onPress={() => darkMode.toggle()}
              className={`bg-inherit ${code === "HNS" || code === "DAD" ? "text-black" : "text-yellow"}`}
              tabIndex={0}
            >
              {darkMode.value ? <Sun /> : <Moon />}
            </Button>
          </NavbarItem>
        </NavbarContent>
      </Navbar>
    </header>
  );
}

export { Header };
